<template>
  <div>
    <v-row>
      <v-col cols="6">
        <span>會員別： 學會之友</span>
      </v-col>
      <v-col cols="6">
        <span>申請類別： 個人</span>
      </v-col>
      <v-col cols="6">
        <span>身分證字號： E100000000</span>
      </v-col>
      <v-col cols="6">
        <span>積分： 0</span>
      </v-col>
      <v-col cols="6">
        <span>中文姓名： 測試中文姓名</span>
      </v-col>
      <v-col cols="6">
        <span>英文姓名： 無</span>
      </v-col>
      <v-col cols="6">
        <span>性別： 男性</span>
      </v-col>
      <v-col cols="6">
        <span>出生日期： 無</span>
      </v-col>
      <v-col cols="6">
        <span>電子信箱： ceo@sita.tech</span>
      </v-col>
      <v-col cols="6">
        <span>公司電話： 無</span>
      </v-col>
      <v-col cols="6">
        <span>行動電話： 無</span>
      </v-col>
      <v-col cols="12">
        <span>戶籍地址： 無</span>
      </v-col>
      <v-col cols="12">
        <span>通訊地址： 無</span>
      </v-col>
      <v-col cols="12">
        <span>現職醫院： 無</span>
      </v-col>
      <v-col cols="6">
        <span>現任職務： 拉拉拉</span>
      </v-col>
      <v-col cols="6">
        <span>科別： 無</span>
      </v-col>
      <v-col cols="12">
        <span>醫院個人介紹： 無</span>
      </v-col>
      <v-col cols="6">
        <span>學歷： 0</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Detail"
};
</script>

<style lang="scss" scoped>
span {
  font-size: 26px;
}
</style>
